import { useMemo } from 'react';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { Avatar, Box, IconButton, Link, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import useNumberFormat from 'hooks/useNumberFormat';
import moment from 'moment';
import DataGridPagination from 'components/pagination/DataGridPagination';

const PDCChequeList = ({
  data,
  setOpen,
  setPayment,
  total,
  paginationModel,
  setPaginationModel,
  loading,
}) => {
  const { currencyFormat } = useNumberFormat();

  const columns = useMemo(
    () => [
      {
        field: 'action',
        headerName: 'Action',
        filterable: false,
        sortable: false,
        align: 'right',
        width: 60,
        headerAlign: 'right',
        renderCell: (params) => {
          return (
            <IconButton
              onClick={() => {
                setOpen(true);
                setPayment(params.row);
              }}
            >
              <ModeEditOutlineOutlinedIcon />
            </IconButton>
          );
        },
      },
      {
        field: 'client',
        headerName: 'Client',
        minWidth: 240,
        sortable: false,
        filterable: false,
        flex: 1,
        renderCell: (params) => {
          const { firstName, lastName, mobile } = params.row.customerId;

          return (
            <Stack
              sx={{
                gap: 1.5,
                alignItems: 'center',
              }}
            >
              <Avatar
                alt={firstName.toUpperCase()}
                src={firstName}
                sx={{ width: 24, height: 24, bgcolor: '#977efdff' }}
              />
              <div>
                <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                  {`${firstName} ${lastName}`}
                </Typography>
                <Link href="#!" variant="caption">
                  {mobile || ''}
                </Link>
              </div>
            </Stack>
          );
        },
      },
      {
        field: 'dateOfCheque',
        headerName: 'Date Of Cheque',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { dateOfCheque } = params.row;
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {dateOfCheque ? moment(dateOfCheque).format('DD/MM/YYYY') : '-'}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'dateOfSubmission',
        headerName: 'Date Of Submission',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { dateOfSubmission, received } = params.row;
          return (
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 400 }}
                color={
                  received ? 'success' : new Date(dateOfSubmission) < new Date() ? 'error' : 'info'
                }
              >
                {dateOfSubmission ? moment(dateOfSubmission).format('DD/MM/YYYY') : '-'}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'dateOfReceive',
        headerName: 'Date Of Receive',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { dateOfReceive, received, bounced = false } = params.row;
          return (
            <Box>
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 400 }}
                color={received ? 'success' : 'error'}
              >
                {bounced
                  ? 'cheque bounced'
                  : dateOfReceive
                    ? moment(dateOfReceive).format('DD/MM/YYYY')
                    : '-'}
              </Typography>
            </Box>
          );
        },
      },

      {
        field: 'amount',
        headerName: 'Amount',
        sortable: false,
        filterable: false,
        minWidth: 150,
        renderCell: (params) => {
          const { amount } = params.row;
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {amount}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'details',
        headerName: 'Details',
        sortable: false,
        filterable: false,
        minWidth: 180,
        flex: 1,
        renderCell: (params) => {
          const { bankName, chequeNumber } = params.row;
          return (
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                {chequeNumber} - {bankName}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: 'audit',
        headerName: 'Last Updated By',
        sortable: false,
        filterable: false,
        minWidth: 150,
        flex: 1,
        renderCell: (params) => {
          const { audit } = params.row;
          return (
            <Stack direction="row" alignItems="center" spacing={1.5}>
              {audit && (
                <Box>
                  <Typography variant="subtitle2">{`${audit?.user.firstName} ${audit?.user.lastName} - ${audit.action}`}</Typography>
                  <Typography variant="caption">
                    {moment(audit.createdAt).format('DD/MM/YYYY HH:mm A')}
                  </Typography>
                </Box>
              )}
            </Stack>
          );
        },
      },
    ],
    [currencyFormat],
  );
  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        loading={loading}
        getRowId={(row) => row._id}
        rowHeight={72}
        rows={data}
        columns={columns}
        pagination
        paginationMode="server"
        rowCount={total}
        paginationModel={paginationModel} // { page: 0, pageSize: 10 }
        onPaginationModelChange={(e) =>
          setPaginationModel((prev) => ({
            page: e.page,
            pageSize: e.pageSize,
            search: prev.search,
          }))
        }
        pageSizeOptions={[1, 5, 10, 20]}
        getRowClassName={(params) => (params.row.bounced ? 'low-stock-row' : '')}
        // checkboxSelection
        // sx={{
        //   '& .margin': {
        //     pr: 3,
        //   },
        //   '& .MuiDataGrid-columnHeaders': {
        //     minWidth: '100%',
        //   },
        // }}
        slots={{
          basePagination: (props) => <DataGridPagination showFullPagination {...props} />,
        }}
      />
    </Box>
  );
};

export default PDCChequeList;
